// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.lba-invalid[data-v-33e59d8c]{background-color:#ffc1c7;border:1px solid #ffaab3}.externalIdsCheck[data-v-33e59d8c]{display:block;text-align:center}.externalIdsCheck p[data-v-33e59d8c]{display:inline-block;margin:0 10px}", ""]);
// Exports
module.exports = exports;
